module.exports = __webpack_public_path__ + "img/pic8.bb2508f1.png";